import { pipelineApi } from '../../../modules/pipeline/api/pipelineApi';

// Backward-compatible alias during migration.
export const dealsApi = pipelineApi;
